import { PetOwnerRoleType } from 'we-tree-api-client/v2';
import { getPetOwnerRoleLabel, PET_OWNER_ROLE_LABELS } from '@/i18n/labelMaps';

export { PET_OWNER_ROLE_LABELS, getPetOwnerRoleLabel };

export type PetOwnerRoleValue = (typeof PetOwnerRoleType)[keyof typeof PetOwnerRoleType];

export const PET_OWNER_ROLE_OPTIONS: { value: PetOwnerRoleValue; label: string }[] = (
  Object.values(PetOwnerRoleType) as PetOwnerRoleValue[]
).map((value) => ({
  value,
  get label() {
    return getPetOwnerRoleLabel(value);
  }
}));
